export const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    fullWidth: {
        width: '80%'
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },
    reviewsSearchResults: {
        marginTop: 10,
    },
    reviewsSearchResultsItems: {
        padding: 10,
    },
    searchReviewActionBtn: {
        float: 'right',
        margin: 10
    },
    headingReviewSearch: {
        display: 'flex',
    },
});


// WEBPACK FOOTER //
// ./src/containers/builder/style/map_section.js